import styled from '@emotion/styled'
import { alpha, Button, ButtonProps } from '@mui/material'

import { WTPayload } from '@f-fertighaus/applications/Next/types/WTPayload'
import { webtrack } from '@f-fertighaus/applications/Next/utils/webtrack'

export const CTAButton = styled(Button)<ButtonProps>(({ theme }) => ({
  textTransform: 'none',
  lineHeight: 1,
  fontFamily: theme.font.fancy,
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary.main}`
  },
  '&.MuiButton-text': {
    fontSize: 14,
    '&:hover': { background: 'none', textDecoration: 'underline' },
    '&.MuiButton-textSecondary': {
      color: theme.palette.text.primary,
      fontFamily: theme.font.base
    }
  },
  '&.MuiButton-contained': {
    fontSize: 16,
    padding: theme.spacing(2, 3),
    '&.MuiButton-containedPrimary': {
      boxShadow: `0 6px 18px -15px ${
        theme.palette.primary.main
      }, 0 5px 30px -5px ${alpha(theme.palette.primary.main, 0.33)}`,
      '&:hover': {
        transform: 'translateY(-1px)',
        backgroundColor: theme.palette.primary.main,
        boxShadow: `0 6px 18px -15px ${
          theme.palette.primary.main
        }, 0 5px 30px -5px ${alpha(
          theme.palette.primary.main,
          0.33
        )}, 0 6px 12px -8px #000`
      },
      '&:focus-visible': {
        outline: `2px solid ${theme.palette.secondary.main}`
      }
    },
    '&.MuiButton-containedSecondary': {
      boxShadow: `0 6px 18px -15px ${
        theme.palette.primary.main
      }, 0 5px 30px -5px ${alpha(theme.palette.secondary.main, 0.6)}`,
      '&:hover': {
        transform: 'translateY(-1px)',
        backgroundColor: theme.palette.secondary.main,
        boxShadow: `0 6px 18px -15px ${
          theme.palette.primary.main
        }, 0 5px 30px -5px ${alpha(
          theme.palette.secondary.main,
          0.6
        )}, 0 6px 12px -8px #000`
      }
    },
    '&.Mui-disabled': {
      boxShadow: 'none'
    }
  },
  '&.MuiButton-outlined': {
    fontSize: 16,
    padding: theme.spacing(2, 3),
    border: `2px solid ${theme.palette.primary.main}`,

    '&:hover': {
      backgroundColor: 'transparent'
    },
    '&.Mui-disabled': {
      boxShadow: 'none'
    }
  }
}))

interface CTAButtonWithWTProps extends ButtonProps {
  wtPayload: WTPayload
}

export const CTAButtonWithWT = ({
  wtPayload,
  children,
  ...rest
}: CTAButtonWithWTProps) => (
  <CTAButton {...rest} onClick={() => webtrack(wtPayload)}>
    {children}
  </CTAButton>
)
